const ViewUsers = () => {
  return <div>View and Edit User</div>;
};

export default ViewUsers;
